<template>
  <div class="AutoList">
    <div class="header">
      <el-input
        size="small"
        placeholder="搜索"
        prefix-icon="el-icon-search"
        v-model="search"
        class="search"
        :clearable="true"
        @input="startSearch"
      >
      </el-input>
      <el-tooltip effect="dark" content="創建自動回復" placement="bottom">
        <el-button
          size="small"
          icon="el-icon-plus"
          circle
          @click="goCreate"
        ></el-button>
      </el-tooltip>
    </div>
    <div class="list" v-loading="loading">
      <el-scrollbar>
        <div
          v-for="(auto, key) in showAutos"
          @click="go(auto)"
          :key="key"
          :class="{ active: currentId == auto.id }"
          class="item"
        >
          <div class="item-desc">
            <p class="item-title">
              {{ auto.word }}
              <span class="item-status" :class="{ disable: !auto.status }">
                ({{ auto.status ? "啟用" : "停用" }})
              </span>
            </p>
            <p class="item-live_id">{{ auto.content }}</p>
          </div>
          <span class="item-id">#{{ auto.id }}</span>
        </div>
      </el-scrollbar>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  name: "AutoList",

  data() {
    return {
      search: null,
      currentId: null,
      autos: [],
      showAutos: [],
      loading: true,
    };
  },

  computed: {
    ...mapState({
      update: (state) => state.common.autoListUpdate,
    }),
  },

  watch: {
    "$route.params.id"() {
      this.init();
    },
    update() {
      this.getAutos();
    },
  },

  mounted() {
    this.init();
    this.getAutos();
  },

  methods: {
    init() {
      this.currentId = this.$route.params.id;
    },

    async getAutos() {
      this.loading = true;

      const result = await this.$fetch("auto");
      if (!result.isOk) {
        this.$message.error(result.message);
        return;
      }

      this.autos = result.data;
      this.startSearch();

      this.loading = false;
    },

    goCreate() {
      this.$router.push("/auto/0");
    },

    go(auto) {
      const path = "/auto/" + auto.id;
      if (this.$route.path == path) {
        return;
      }

      this.$router.push(path);
    },

    startSearch() {
      const search = this.search;
      if (!search) {
        this.showAutos = this.autos;
        return;
      }

      this.showAutos = this.autos.filter((auto) => {
        if (
          auto.content.indexOf(search) > -1 ||
          auto.word.indexOf(search) > -1
        ) {
          return true;
        }

        return false;
      });
    },
  },
};
</script>
<style scoped lang="less">
.AutoList {
  width: 250px;
  height: 100%;
  background: #eee;
  display: inline-block;

  .header {
    padding: 10px;
    height: 32px;
    border-bottom: 1px #ddd solid;

    .search {
      margin-right: 8px;
      width: 190px;
    }
  }

  .list {
    height: 732px;
  }

  .item {
    padding: 10px;
    position: relative;
    display: flex;
    align-content: center;
    border-bottom: 1px dashed #ddd;

    &:last-child {
      border: none;
    }

    &.active {
      background: #ddd;
    }

    &:hover {
      background: #d2d2d2;
      cursor: pointer;
    }

    .item-desc {
      padding-left: 5px;
      display: inline-block;

      p {
        min-height: 20px;
        line-height: 20px;
        margin: 0;
        padding: 0;

        &.item-live_id {
          font-size: 12px;
          color: #a1a1a1;
        }
      }
    }

    .item-status {
      color: #333;
      font-size: 12px;

      &.disable {
        color: red;
      }
    }

    .item-id {
      position: absolute;
      top: 10px;
      right: 10px;
      color: #a1a1a1;
    }
  }
}
</style>